import { Help, WithModelField } from 'components/inputs'
import { observer } from 'mobx-react'
import { formatMoney } from 'utils/money-util'
import React, { useCallback } from 'react'
import { action } from 'mobx'
import { asNumber } from 'utils/number-util'
import { TableCell } from 'components/Table'
import styles from './MoneyCell.sass'

interface MoneyCellProps<T, K extends keyof T>
  extends WithModelField<T, K, number | null> {
  editable: boolean
  children: number
  dataTest?: string
  error?: string
}

export default observer(function MoneyCell<T, K extends keyof T>({
  editable,
  model,
  field,
  children,
  dataTest,
  error,
}: MoneyCellProps<T, K>) {
  const amount = formatMoney(children, true)

  const onChange = useCallback(
    action((e: React.ChangeEvent<HTMLInputElement>) => {
      ;(model as any)[field] = e.target.value
        ? asNumber(e.target.value)
        : undefined
    }),
    [model, field],
  )

  return (
    <TableCell>
      <div className={styles.money}>
        {editable ? (
          <>
            <input
              className={styles.moneyInput}
              onChange={onChange}
              type="number"
              step="0.01"
              value={(model[field] || '') as unknown as number}
              data-test={dataTest}
            />
            <Help error={error} />
          </>
        ) : (
          amount
        )}
      </div>
    </TableCell>
  )
})
